<template>
  <section class="c-section-outstream">
    <div
      v-if="isActive"
      class="c-section-outstream__content"
    >
      <ui-ad-intext-roll
        v-if="isFreewheelAdSystem"
        :params="getFWAdParams()"
      ></ui-ad-intext-roll>
      <v-ad-banner
        v-else-if="spaceId && isHQSmartAd"
        :ad-system="adSystem"
        :space-id="spaceId"
      ></v-ad-banner>
    </div>
  </section>
</template>

<script>
  import { AdSystem } from '@/shared/enums';
  import { UiAdIntextRoll } from '@/index/components';
  import { VAdBanner } from '@/index/shared/components';
  import { viewportMixin } from '@/index/shared/mixins';

  export default {
    name: 'Outstream',
    components: {
      VAdBanner,
      UiAdIntextRoll,
    },
    enums: {
      AdSystem,
    },
    mixins: [
      viewportMixin,
    ],
    inject: ['$section'],
    data() {
      return {
        info: this.$services.resolve('info'),
        isActive: false,
        height: null,
        width: null,
      };
    },
    computed: {
      adSystem() {
        return this.$section.resource?.configuration?.adSystem;
      },
      spaceId() {
        return this.$section.resource?.configuration?.spaceId;
      },
      isFreewheelAdSystem() {
        return this.adSystem === AdSystem.FREEWHEEL;
      },
      isHQSmartAd() {
        return this.adSystem === AdSystem.SMART_AD;
      },
    },
    mounted() {
      this.load();
    },
    beforeMount() {
      this.setSizes();
    },
    methods: {
      getFWAdParams() {
        const { freeWheelInfo } = this.info;
        const zoneId = freeWheelInfo?.zoneId;
        const lang = this.$i18n.locale.toLowerCase();

        return zoneId ? `zone=${zoneId}&width=${this.width}&height=${this.height}&lang=${lang}` : '';
      },
      load() {
        this.observe();
      },
      onViewportEnter() {
        if (this.isActive) {
          return;
        }

        this.isActive = true;
      },
      setSizes() {
        if (this.$window.isMobileView) {
          this.height = 250;
          this.width = 300;
          return;
        }

        if (this.$window.isBelowFullHdView) {
          this.height = 200;
          this.width = 980;
          return;
        }

        this.height = 400;
        this.width = 1000;
      },
    },
  };
</script>
